import {Trans, useTranslation} from "react-i18next";
import OpayInfoContactEmail from "../trans/OpayInfoContactEmail.tsx";
import OfficerContactEmail from "../trans/OfficerContactEmail.tsx";
import LbInfoContactEmail from "../trans/LbInfoContactEmail.tsx";
import FrptContactEmail from "../trans/FrptContactEmail.tsx";
import OpayComplianceContactEmail from "../trans/OpayComplianceContactEmail.tsx";
import OpayCeoContactEmail from "../trans/OpayCeoContactEmail.tsx";
import OpayPrivacyContactEmail from "../trans/OpayPrivacyContactEmail.tsx";

const LegalPageSectionParagraphTransComponent = ({text, locale}: {text: string|undefined, locale?: string}) => {

    const {t} = locale ? useTranslation('translation', {lng: locale}) : useTranslation();

    return (
        <>
            <Trans t={t} components={{
                lrvComplaint: <a href="https://vdai.lrv.lt/lt/veiklos-sritys-1/skundu-nagrinejimas/" />,
                cookiesPolicy: <a href={`/${t('routes.cookies_policy')}`} target="_blank" />,
                cookiesPolicyEn: <a href={`/en/legal-information/cookies-policy`} target="_blank" />,
                privacyEmail: OpayPrivacyContactEmail(),
                contactEmail: OpayInfoContactEmail(),
                officerEmail: OfficerContactEmail(),
                phone: <a href="tel:+37061155554" />,
                officerPhone: <a href="tel:+37052548240" />,
                privacyPolicy: <a href={`/${t('routes.privacy_policy')}`} target="_blank" />,
                privacyPolicyRussian: <a href={'/politika-konfidencialnosti'} target="_blank" />,
                opayWebsite: <a href="https://opay.eu" target="_blank" />,
                lbDisputes: <a href="https://www.lb.lt/lt/spreskite-ginca-su-finansiniu-paslaugu-teikeju#ex-1-4"
                               target="_blank" />,
                lb: <a href={t('lbLink')} target="_blank" />,
                lbInfo: LbInfoContactEmail() ,
                frptLb: FrptContactEmail(),
                vvtat: <a href={t('vvtatLink')} target="_blank" />,
                ada: <a href={t('adaLink')} target="_blank" />,
                website: <a href="https://opay.eu" target="_blank" />,
                neopay: <a href="https://neopay.online/lt/term-of-service" target="_blank" />,
                dokobitLt: <a href="https://www.dokobit.com/lt" target="_blank" />,
                dokobitEn: <a href="https://www.dokobit.com" target="_blank" />,
                lbFraud: <a href="https://www.lb.lt/lt/sukciavimo-budai" target="_blank" />,
                pricing: <a href={`/${t('routes.pricing')}`} target="_blank" />,
                paymentTerms: <a href={`/${t('routes.payment_terms')}`} target="_blank" />,
                paymentMethods: <a href={`/${t('routes.payment_methods')}`} target="_blank" />,
                citadele: <a href="https://www.citadele.lv" target="_blank" />,
                disputes: <a href={`/${t('routes.complaint_submission')}`} target="_blank" />,
                complianceEmail: OpayComplianceContactEmail(),
                ceoEmail: OpayCeoContactEmail(),
                wrongdoingForm: <a href={`/user/themes/opay-theme/images/wrongdoing_report_form_EN.docx`} target="_blank" />,
                citadeleAgreement: <a href="https://online.citadele.lv/pwww/apps/p/agreement_doc/language/en/location/LV/residence/RN/service/CARD/type/J/?filename=agreement.pdf" target="_blank" />,
                paystraxTerms: <a href="https://paystrax.com/wp-content/uploads/2025/07/Terms-for-PAYSTRAXs-MFA-v.1.3-1.pdf" target="_blank" />,
                smartIdUpgradeLt: <a href="https://www.smart-id.com/lt/help/faq/smart-id-atnaujinimas/smart-id-basic-paskyros-naujinimas/" target="_blank" />,
                smartIdUpgradeEn: <a href="https://www.smart-id.com/help/faq/update-your-smart-id/upgrading-your-smart-id-basic-account/" target="_blank" />,
            }}>
                {text}
            </Trans>
        </>
    )
}

export default LegalPageSectionParagraphTransComponent;
